// owner status
export const STATUS_ACTIVE = 'active'
export const STATUS_ON_GOING = 'onGoing'
export const STATUS_DONE = 'onGoing/done'
export const STATUS_DRAFTS = 'drafts'
export const STATUS_CLOSED = 'closed'

// owner options
export const OWNER_MY = 'my'
export const OWNER_OTHERS = 'others'
